import React, { useState } from "react";
import { QualityCheckAction, ScanActionApiResponseNew } from "../scanners/types";
import { BagCard } from "@/components/ScannerActions/BagCard";
import { Order, OrderBag, Bin, REPAIR_STATUS, ORDER_TYPE, PAYMENT_STATUS, BIN_POSITION, ORDER_BAG_STATUS } from "@/types";
import { BinCard } from "@/components/ScannerActions/BinCard";

const bin: Bin = {
  id: 123,
  name: "1004B / 22 ltr",
  category: "CA12",
  position: BIN_POSITION.LOWER_BACKSIDE,
  content: 22,
  active: true,
};

const orderBag = {
  id: "123",
  sequence: 1,
  status: ORDER_BAG_STATUS.NONE,
};

const order = {
  id: "dd80b9ea-6318-4699-939d-34848f4cd2ab",
  friendlyId: "20253698136",
  urgent: false,
  paymentStatus: PAYMENT_STATUS.PAID,
  paymentMethod: null,
  proforma: false,
  internal: true,
  brand: "my-brand",
  type: ORDER_TYPE.CAR,
  guarantee: false,
  comment: "",
  internalComment: "",
  products: [],
  status: REPAIR_STATUS.UNPACKING,
  startUnpackingAt: "",
  endUnpackingAt: "",
  startBookingAt: "",
  endBookingAt: "",
  createdAt: "",
  updatedAt: "",
  winfaktSalesId: null,
  dash: null,
  dashAdvancePayment: null,
};

const reponseStates: ScanActionApiResponseNew[] = [
  {
    code: "ORDER_NOT_FOUND",
    isValid: false,
    action: QualityCheckAction.BIN_BAGS,
  },
  {
    code: "ORDER_BAG_NOT_FOUND",
    isValid: false,
    action: QualityCheckAction.BIN_BAGS,
    bin,
    order,
  },
  {
    code: "BIN_NOT_FOUND",
    isValid: false,
    action: QualityCheckAction.BIN_BAGS,
    order,
  },
  {
    code: "BINS_DO_NOT_MATCH",
    isValid: false,
    action: QualityCheckAction.BIN_BAGS,
    bin,
    order,
    orderBag,
  },
  {
    code: "BIN_AND_BAG_MATCH",
    isValid: true,
    action: QualityCheckAction.BIN_BAGS,
    bin,
    order,
    orderBag,
  },
];

export const KwcBinsTest: React.FC = () => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [order, _setOrder] = useState<Partial<Order> | null>(null);
  const [bin, _setBin] = useState<Partial<Bin> | null>(null);
  const [orderBag, _setOrderBag] = useState<Partial<OrderBag> | null>(null);
  const [qualityCheckResponse, _setQualityCheckResponse] = useState<ScanActionApiResponseNew | null>(null);

  const handleTestDataChange = (value: string) => {
    if (value === "") {
      setSelectedIndex(null);
      _setOrder(null);
      _setBin(null);
      _setOrderBag(null);
      _setQualityCheckResponse(null);
    } else {
      const index = Number(value);
      setSelectedIndex(index);
      const newTestData = reponseStates[index];
      _setOrder(newTestData?.order || null);
      _setBin(newTestData?.bin || null);
      _setOrderBag(newTestData?.orderBag || null);
      _setQualityCheckResponse(newTestData);
    }
  };

  return (
    <>
      <div style={{ marginBottom: '20px', padding: '10px', border: '1px solid #ccc' }}>
        <label htmlFor="test-selector">Test Data: </label>
        <select
          id="test-selector"
          value={selectedIndex ?? ""}
          onChange={(e) => handleTestDataChange(e.target.value)}
        >
          <option value="">-- None (Reset) --</option>
          {reponseStates.map((state, index) => (
            <option key={index} value={index}>
              {state.code} ({state.isValid ? 'Valid' : 'Invalid'})
            </option>
          ))}
        </select>
      </div>

      <BinCard data={qualityCheckResponse} bin={bin} order={order} />
      <BagCard data={qualityCheckResponse} orderBag={orderBag} />
    </>
  );
};

export default KwcBinsTest;
